import rosterBackendService from './RosterBackendService';
import provisionService from '../services/ProvisionService';
import { TestDateDTO, TestDateFilterDTO } from '@beable/roster-backend-client-v1';
import { TestDate, defaultTestDate, getUtcDateString, validateForm } from '../components/Courses/TestDates/TestDate.helper';

async function getAllTestDates(filter: TestDateFilterDTO) {  
  const response = await rosterBackendService.getAllTestDates(filter);

  if (response.isOk()) {
    const testDates: TestDate[] = response.value;
    const siteIds = new Set<number>();
    const customerAndSiteIds = new Set<[string, number]>();
    const customerIds = new Set<string>();

    if (testDates) {
      for (const testDate of testDates) {
        siteIds.add(testDate.siteId);
        customerAndSiteIds.add([testDate.customerId, testDate.siteId]);
        customerIds.add(testDate.customerId);
        testDate.testDate = getUtcDateString(testDate.testDate, 'yyyy-MM-dd');
      }
    }
    return testDates;
  }
  return null;
}

async function deleteTestDate(id: string) {
  const response = await rosterBackendService.deleteTestDate(id);
  if (response.isOk()) {
      return response.value;
  }
  return null;
}

async function saveTestDate(
  customerId: string,
  siteId: number,
  productId: string,
  academicYearId: string,
  courseCode: string,
  testDate: string,
  id?: string,
  savedTestDate?: string,
) {
  const customersResult = await provisionService.getCustomers();
  const site = await provisionService.getSitesById(siteId);
  const customerProducts = await provisionService.getSiteProducts(customerId, siteId);
  const siteAcademicYearsResponse = await provisionService.getAcademicYears(siteId);
  const siteAcademicYears = siteAcademicYearsResponse?.academicYears;
  const testDatePayload: TestDate = Object.assign({}, defaultTestDate);
  testDatePayload.id = id;
  testDatePayload.courseCode = courseCode;
  testDatePayload.testDate = testDate;

  if(customersResult) {
    const customer = customersResult.find((item) => item.id === customerId);
    testDatePayload.customerName = customer?.name || '';
    testDatePayload.customerId = customer?.name ? customerId : '';
  }

  if (site) {
    testDatePayload.siteSubdomain = site.subdomain;
    testDatePayload.siteId = site?.subdomain ? siteId : 0;
  }

  if (customerProducts) {
    const product = customerProducts.find((item) => item.id === productId);
    testDatePayload.productName = product?.name || '';
    testDatePayload.productId = product?.name ? productId : '';
  }

  if (siteAcademicYears) {
    const siteAcademicYear = siteAcademicYears.find(
      (item) => item.academicYearId === academicYearId,
    );
    testDatePayload.schoolYear = siteAcademicYear?.schoolYear || 0;
    testDatePayload.academicYearId = siteAcademicYear?.schoolYear ? academicYearId : '';
  }

  const validation = await validateForm(
    testDatePayload.customerId,
    testDatePayload.siteId,
    testDatePayload.productId,
    testDatePayload.academicYearId,
    testDatePayload.courseCode,
    testDatePayload.testDate,
    savedTestDate,
  );

  if (validation.isInvalid) {
    return { validation };
  }

  testDatePayload.testDate = new Date(testDate).toISOString();
  const response = await rosterBackendService.saveTestDate(testDatePayload as TestDateDTO);
  const success: any = 'Test date added successfully!';

  if(response.isErr()) {
    if(response.error.result.isJust()) {
      return { error: response.error.result.value.message };
    }
    return { error: response.error.message };
  }
  return { success };
}

export default {
  getAllTestDates,
  saveTestDate,
  deleteTestDate,
}